// extracted by mini-css-extract-plugin
export default {"header":"IdoFe","title":"_6yWkr","wrapper":"uyu74","wrapperContainer":"Q+smu","container":"JuOBc","mainContentWrapper":"NcfvW","footer":"-NKvc"};